const generateProductSlipImage = async (imageUrl, measurements, configuration) => { 
    if (!configuration) {
        throw new Error("Configuration not found in PatioContext.");
    }

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = imageUrl;
    
    await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = reject;
    });
    
    let { naturalWidth, naturalHeight } = image;
    const maxDimension = 1024;
    const aspectRatio = naturalWidth / naturalHeight;
    
    if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        if (naturalWidth > naturalHeight) {
            naturalWidth = maxDimension;
            naturalHeight = Math.round(maxDimension / aspectRatio);
        } else {
            naturalHeight = maxDimension;
            naturalWidth = Math.round(maxDimension * aspectRatio);
        }
    }

    const canvas = document.createElement("canvas");
    canvas.width = naturalWidth;
    canvas.height = naturalHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const scale = (value) => value * (canvas.width / 1024); 
           
    const drawShape = (shape, scaleX, scaleY, options = {}) => {
        const {
            radius = 0, width = 0, height = 0, fontSize = 0, text = "", 
            fillColor = "#000", textColor = "#fff", textAlign = "center", textBaseline = "middle", 
        } = options;

        ctx.font = `${fontSize}px Arial`;
        ctx.textAlign = textAlign;
        ctx.textBaseline = textBaseline;
        
        ctx.save();
        ctx.beginPath();
        if (shape === "circle") {
            ctx.arc(scaleX, scaleY, radius, 0, Math.PI * 2);
        } else if (shape === "rect") {
            ctx.roundRect(scaleX - width / 2, scaleY - height / 2, width, height, radius);
        }
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.restore();

        if (text) {
            ctx.save();
            ctx.fillStyle = textColor;
            ctx.fillText(text, scaleX, scaleY);
            ctx.restore();
        }
    };

    measurements.forEach((measurement, index) => {
        const { x, y, key } = measurement;
        if (!x || !y) return;
        const scaledX = x * canvas.width;
        const scaledY = y * canvas.height;
        const dot = String.fromCharCode(65 + index);
        const tooltip = configuration[key] || "N/A";
        
        // Dot
        const dotFontSize = scale(36);
        const dotPadding = scale(8);
        const dotRadius = (dotFontSize + dotPadding * 2) / 2;
        drawShape("circle", scaledX, scaledY, {
            radius: dotRadius,
            fillColor: "#00344e",
            text: dot,
            textColor: "#ffcb04",
            fontSize: dotFontSize,
        });

        // Tooltip
        const tooltipFontSize = scale(28);
        const tooltipPadding = scale(6);
        const tooltipWidth = ctx.measureText(tooltip).width + tooltipPadding * 2 + scale(8);
        const tooltipHeight = tooltipFontSize + tooltipPadding * 2;
        const tooltipRadius = scale(6);
        const tooltipY = scaledY - dotRadius * 2 - scale(5);
        drawShape("rect", scaledX, tooltipY, {
            width: tooltipWidth,
            height: tooltipHeight,
            radius: tooltipRadius,
            fillColor: "#00344e",
            text: `${tooltip}"`,
            textColor: "#ffcb04",
            fontSize: tooltipFontSize,
        });

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(scaledX - (tooltipWidth / 2) / 2, tooltipY + tooltipHeight / 2);
        ctx.lineTo(scaledX + (tooltipWidth / 2) / 2, tooltipY + tooltipHeight / 2);
        ctx.lineTo(scaledX, scaledY - dotRadius);
        ctx.fillStyle = "#00344e";
        ctx.fill();
        ctx.restore();
    });

    return canvas.toDataURL("image/png");
};

export default generateProductSlipImage;
